export default {
  common: {
    add: 'Add',
    edit: 'Edit',
    detail: 'Details',
    delete: 'Delete',
    batchDelete: 'Batch delete',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    refresh: 'Refresh',
    print: 'Print',
    columnSettings: 'Column settings',
    action: 'Actions',
    confirm: 'Confirm',
    cancel: 'Cancel',
    noData: 'No data',
    inputPlaceholder: 'Please enter',
    selectPlaceholder: 'Please select',
    datePlaceholder: 'Select a date',
    timePlaceholder: 'Select a time',
    startTime: 'Start time',
    endTime: 'End time',
    operationSucceeded: 'Operation succeeded',
    deleteSucceeded: 'Deleted',
    deleteConfirmTitle: 'Delete confirmation',
    deleteConfirm: 'Deleting “{content}” may invalidate related business data and cannot be undone. Confirm the impact before continuing.',
    selectedItems: '{count} selected'
  },
  app: {
    title: 'Ask Spinner Admin',
    home: 'Home',
    foundation: 'Foundation',
    componentLibrary: 'Common components',
    richTextEditor: 'Rich text editor',
    placeholderTitle: 'Admin foundation is ready',
    placeholderDescription: 'Business pages have not been connected. Vue, Element Plus, and the shared component foundation are ready.'
  }
}
